const OR = {
  // Currency
  currency: "ريال سعودي",

  // Buttons Labels Repeated
  "modal-ok-btn": "ٹھیک ہے",
  "send-btn": "بھیجیں",
  "cancel-btn": "منسوخ کریں۔",

  // ==========================================================================================================================================
  // Error Messages
  "phone-number-error": "براہ کرم ایک فون نمبر درج کریں۔",
  "password-error": "برائے مہربانی اپنا پاس ورڈ داخل کریں",
  "confirm-password-error": "براہ کرم پاس ورڈ کی تصدیق کریں۔",
  "user-name-error": "براہ کرم اپنا صارف نام درج کریں۔",
  "confirm-code-error": "براہ کرم کوڈ درج کریں۔",

  // Input Error Messages
  "user-name-input-error":
    "براہ کرم یقینی بنائیں کہ درج کردہ صارف نام درست ہے۔",
  "phone-number-input-error":
    "براہ کرم یقینی بنائیں کہ درج کردہ فون نمبر درست ہے۔",
  "password-input-error": "براہ کرم یقینی بنائیں کہ درج کردہ پاس ورڈ درست ہے۔",
  "confirm-password-input-error": "براہ کرم پاس ورڈ کی درست تصدیق کریں۔",
  // ==========================================================================================================================================
  // Navbar
  "arabic-key": "عربی",
  "english-key": "انگریزی",
  "urdu-key": "اردو",
  "hindi-key": "ہندی",
  "main-tab": "مرکزی",
  "notification-tab": "اطلاعات",
  "orders-tab": "آرڈرز کو ٹریک کریں۔",
  "settings-tab": "ترتیبات",
  "user-name": "صارف کا نام",
  "sign-out": "باہر جائیں",
  // ==========================================================================================================================================
  // StartUp
  "Startup-form-header": "اپنا سامان صاف کرو",
  "Startup-box-text-1": "بہت ساری چیزیں ہیں جن کی صفائی کی ضرورت ہے؟",
  "Startup-box-text-2":
    "آرام کریں اور اپنی ضرورت کی ہر چیز کو صاف کرنے کے لیے ہمیں کال کریں۔",
  "Startup-box-text-3":
    "آپ کس چیز کا انتظار کر رہے ہیں؟ ابھی ہمارے ساتھ شامل ہوں۔",
  "Lets-start-btn": "شروع کرتے ہیں",

  // Copy Rights Start
  "copy-rights-start-1": "کوئی سوال ہے؟",
  "copy-rights-start-2": "ہم سے رابطہ کریں۔",
  "copy-rights-start-3": "صفائی کی خدمات ایپ",
  "copy-rights-start-4": "| جملہ حقوق محفوظ ہیں",
  "copy-rights-start-5": "اسٹیک سافٹ کمپنی کے ذریعہ تیار کردہ",

  // ==========================================================================================================================================
  // LogIn
  "login-form-header": "لاگ ان کریں",
  "login-phone-number-label": "فون نمبر",
  "login-phone-number-text":
    "ہم آپ کا فون نمبر کبھی بھی کسی اور کے ساتھ شیئر نہیں کریں گے۔",
  "login-phone-number-placeholder": "فون نمبر",
  "login-password-label": "پاس ورڈ",
  "login-password-placeholder": "پاس ورڈ",
  "login-btn-text": "لاگ ان کریں",
  "login-no-account-text": "ابھی تک اکاؤنٹ نہیں ہے؟",
  "login-no-account-signup": "سائن اپ",
  "login-method-text": "یا اس کے ساتھ لاگ ان کریں۔",
  "login-method-1-text": "Google",
  "login-method-2-text": "Apple",

  // ==========================================================================================================================================
  // SignUp
  "signup-form-header": "سائن اپ",
  "confirm-signup-form-header": "تصدیقی مرحلہ",
  "confirm-signup-please-input-code": "براہ کرم تصدیقی کوڈ درج کریں۔",
  "confirm-signup-code-is-sent-to": "کوڈ اس نمبر پر بھیج دیا گیا ہے: ",
  "confirm-signup-ask-if-receive-code": "کوڈ موصول نہیں ہوا؟ ",
  "confirm-signup-re-send-code": "دوبارہ ٹرانسمیٹر",
  "confirm-signup-verify-code": "تصدیق",
  "confirm-signup-close-code": "بند کریں",
  "signup-phone-number-text":
    "ہم آپ کا فون نمبر کبھی بھی کسی اور کے ساتھ شیئر نہیں کریں گے۔",
  "signup-phone-number-placeholder": "فون نمبر",
  "signup-user-name-placeholder": "اسم المستخدم",
  "building-number": "نمبر بنانا",
  "floor-number": "منزل نمبر",
  "signup-password-placeholder": "پاس ورڈ",
  "signup-password-confirm-placeholder": "پاس ورڈ کی تصدیق کریں",
  "signup-btn-text": "سائن اپ",
  "signup-method-text": "یا اس کے ساتھ سائن اپ کریں۔",
  "signup-method-1-text": "Google",
  "signup-method-2-text": "Apple",

  // ==========================================================================================================================================
  // Main
  // Main Navbar
  "search-main-tab": "ایک لانڈرومیٹ تلاش کریں۔",
  "fav-main-tab": "پسندیدہ",
  "recently-main-tab": "حال ہی میں استعمال کیا",
  "request-main-tab": "سروس کی درخواست",
  // ==========================================================================================================================================
  // Search Washer
  "Search-box-placeholder": "نام سے تلاش کریں۔...",
  "laundry-location-label-card": "لانڈرومیٹ کا مقام: ",
  "rate-filter-search-washer": "سب سے زیادہ درجہ بندی",
  "near-filter-search-washer": "قریب ترین",
  "rate-max-to-min": "سب سے زیادہ درجہ بندی سے کم ترین درجہ بندی تک",
  "rate-min-to-max": "کم سے کم درجہ بندی سے زیادہ تر تک",
  "choose-city": "ایک شہر منتخب کریں۔",
  "sort-starting-with": "سے ترتیب دیں۔",
  "discount-label": "رعایت",
  "free-deliver-label": "مفت ترسیل",
  "no-laundromats": "ابھی تک کوئی لانڈری نہیں ہے۔",

  // ==========================================================================================================================================
  // Laundry Modal
  "laundry-services-label": "لانڈرومیٹ کی خدمات: ",
  "request-service-button": "سروس کی درخواست",
  "move-to-map-button": "نقشے پر منتقل کریں۔",
  "services-laundry-table-column": "خدمات دے دی گئیں",
  "size-laundry-table-column": "سرونگ سائز",

  // ==========================================================================================================================================
  // Service Request
  "choose-type": "ویجیٹ کی قسم کا انتخاب کریں۔",
  "choose-type-first": "پہلے ویجیٹ کی قسم کا انتخاب کریں۔",
  "check-box-take-your-order":
    "آپ کا آرڈر لینا اور اسے ہمارے ڈیلیوری نمائندوں کے ذریعے ہمیں واپس کرنا",
  "choose=service-type-select-option": "سروس کی قسم کا انتخاب کریں۔",
  "send-request-service": "درخواست بھیجیں",
  "specify-current-location": "اپنا موجودہ مقام منتخب کریں۔:",
  "span-under-location-row":
    "*گاہک کی آپ تک رسائی کو آسان بنانے کے لیے آپ کے موجودہ مقام کے نقاط خود بخود لیے جائیں گے۔",
  "no-services-yet": "کوئی دوسری خدمات نہیں ہیں۔",
  "price-after-discount": "رعایت کے بعد قیمت:",
  "price-after-free-delivery": "ڈیلیوری فیس کی کٹوتی کے بعد قیمت:",

  // ==========================================================================================================================================
  // Settings
  // Settings Navbar
  "password-settings-tab": "پاس ورڈ",
  "user-info-settings-tab": "صارف کی معلومات",
  "location-settings-tab": "مقام",
  "Terms-Conditions-settings-tab": "شرائط و ضوابط",
  "system-work-settings-tab": "سسٹم کا کام",
  // ==========================================================================================================================================
  // System Change Password
  "system-user-name-change-label": "صارف کا نام",
  "system-phone-change-label": "فون نمبر",
  "system-old-password-change-label": "پرانا پاسورڈ",
  "system-password-change-label": "نیا پاس ورڈ",
  "system-confirm-password-change-label": "نئے پاس ورڈ کی توثیق کریں",
  "system-password-btn-change-label": "تصدیق کریں",
  // ==========================================================================================================================================
  // System Change Location
  "system-location-change-label": "آپ کا موجودہ مقام",
  "system-location-change-note":
    "اگر آپ مقام کو دستی طور پر متعین کرتے ہیں، تو براہ کرم اس کی درست وضاحت کریں۔",
  "system-location-btn-auto-label": "مقام خود بخود سیٹ کریں۔",
  "system-location-btn-change-label": "تصدیق کریں",
  // ==========================================================================================================================================
  // System Work
  Bronze: "کانسی",
  Silver: "چاندی",
  Gold: "سونا",
  Diamond: "ہیرا",

  // ==========================================================================================================================================
  // Notifications
  // Notifications Texts
  "Laundry-Accept": "آپ کا لانڈری آرڈر قبول کر لیا گیا ہے۔",
  "Laundry-Reject": "آپ کے لانڈری آرڈر سے انکار کر دیا گیا ہے۔",
  "Delivery-Accept": "آپ کی درخواست ڈیلیوری سے موصول ہوئی ہے۔",
  "Laundry-Received-order":
    "آپ کا آرڈر لانڈرومیٹ پر پہنچ گیا ہے اور جب یہ ہو جائے گا تو ہم آپ کو بتائیں گے۔",
  "Laundry-start-washing-notification": "آپ کے آرڈر کی تفصیلات یہ ہیں۔",
  "Laundry-finish-washing-ready-Delivering": "آپ کی درخواست مکمل ہو گئی ہے۔",
  "Free-Delivery-notif": "",
  "Discount-notif": "",
  "Delivered-state": "آپ کی درخواست کامیابی کے ساتھ پہنچا دی گئی ہے۔",
  "order-num-notification": "آرڈر نمبر: ",
  "rate-send-notification": "آپ کا تجربہ کیسا رہا؟ ",
  "note-send-notification": "آپ کی رائے کیا ہے؟ ",

  // Notifications Table details
  "item-type-column-notification": "چیز کی قسم",
  "service-type-column-notification": "سروس کی قسم",
  "number-of-items-column-notification": "اشیاء کی تعداد",
  "price-column-notification": "قیمت",

  // ==========================================================================================================================================
  // Orders
  // Orders Navbar
  "my-orders-nav": "میرے احکام",
  "done-orders-nav": "میرے مکمل احکامات",

  // Order Statuses
  "Waiting-Laundry-Accept": "زیر التواء لانڈری قبولیت",
  "Waiting-Delivery-Accept": "زیر التواء ڈیلیوری مین استقبالیہ قبولیت",
  "Delivery-Taking-Order-from-user": "کلائنٹ سے لایا جا رہا ہے",
  "Delivery-Taking-Order-to-Laundry": "کپڑے دھونے کے لیے لایا جا رہا ہے۔",
  "Waiting-Laundry-start-washing": "پری پروسیسنگ",
  "Laundry-start-washing": "پروسیسنگ",
  "Ready-to-Deliver": "ڈیلیوری کے لیے تیار ہے۔",
  "Waiting-Delivery-Taking-Accept": "زیر التواء ڈیلیوری مین ڈیلیوری قبولیت",
  "Delivery-ReturnBack-Order-from-Laundry": "لانڈری سے لایا جا رہا ہے۔",
  "Delivery-ReturnBack-Order-to-user": "کلائنٹ کے پاس لایا جا رہا ہے۔",
  "Delivered-order-to-user": "ہو گیا",

  // Order Labels
  "Laundry-name-label-order": "لانڈرومیٹ کا نام: ",
  "Delivery-name-label-order": "مندوب کا نام: ",
  "Date-label-order": "تاریخ کی تخلیق ",
  "Type-label-order": "آرڈر کی قسم: ",
  "details-name-btn-order": "آرڈر کی تفصیلات",

  // Order Details Modal and Table
  "item-type-column": "چیز کی قسم",
  "service-type-column": "سروس کی قسم",
  "number-of-items-column": "اشیاء کی تعداد",
  "price-column": "قیمت",
  "price-label-modal": "کل قیمت: ",
  "price-cost-label-modal": "لاگت: ",
  "price-commission-label-modal": "کمیشن: ",

  // delivering Orders Types
  "delivery-two-ways": "یہ مندوبین کے ذریعہ لیا اور دیا جاتا ہے۔",
  "delivery-one-way": "صرف مندوبین کے ذریعہ لیا گیا۔",

  // ==========================================================================================================================================

  // Contact Us

  // ******  Headers
  "contactUs-header": "Contact Us",
  "first-contactUs-header": "Contact Information",
  "second-contactUs-header": "Leave Us a message",

  // ******  Communicate Column
  "location-communicate-label": "Address",
  "location-communicate-value": "Jordan Jordan Jordan",
  "phone-communicate-label": "Phone",
  "phone-communicate-value": "0999999999",
  "email-communicate-label": "E-mail Address",
  "email-communicate-value": "example@gmail.com",

  // ******  send message Column
  "name-label": "Name",
  "name-placeholder": "your name",
  "email-send-message-label": "E-mail Address",
  "email-send-message-placeholder": "example@gmail.com",
  "message-contactUs-label": "Message",
  "message-contactUs-placeholder": "what do you want to tell us ?",
  "button-send-message-contactUs": "Send",

  // ==========================================================================================================================================
};

export default OR;
